import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";

const CustomButton = styled(Button)(({ theme }) => ({
  borderRadius: "20px",
  color: "#ffffff",
  fontSize: "12px",
  fillRule: "evenodd",
  textTransform: "none",
  backgroundColor: "rgba(255,255,255,0.09803921568627451 )",
  padding: "1px",
  paddingRight: "10px",
  paddingLeft: "10px",
  "&:hover": {
    backgroundColor: "#36899f",
    boxShadow: "none",
  },
  boxShadow: "none",
}));

const GlobalButton = styled(CustomButton)(({ theme }) => ({
  background: "rgba(255,255,255,0.09803921568627451 )",
  "&:hover": {
    backgroundColor: "rgba(255,255,255,0.09803921568627451 )",
  },
}));

const YellowButton = styled(CustomButton)(({ theme }) => ({
  background: "#ddb930",
  "&:hover": {
    backgroundColor: "#ddb930",
  },
}));

const SkyButton = styled(CustomButton)(({ theme }) => ({
  background: "#36899f",
  "&:hover": {
    backgroundColor: "#36899f",
  },
}));

interface smallButtonProps {
  color?: string,
  text: string,
  isClicked?: boolean,
  style?: Object,
}

const SmallButton:React.FC<smallButtonProps> = ({color,text,isClicked,style}) => {
  return color === "yellow" && isClicked === true ? (
    <YellowButton variant="contained" style={style}>{text}</YellowButton>
  ) : color === "sky" && isClicked === true ? (
    <SkyButton variant="contained" style={style}>{text}</SkyButton>
  ) : color === "none" && isClicked === true ? (
    <GlobalButton variant="contained" style={style}>{text}</GlobalButton>
  ) : (
    <GlobalButton variant="contained" style={style}>{text}</GlobalButton>
  );
}

export default SmallButton;
